import { css, html, LitElement } from "lit";
import { customElement, property } from "lit/decorators.js";

@customElement("pg-toggle-switch")
export class PGDToggleSwitch extends LitElement {
  @property({ type: Boolean }) checked = false;
  @property({ type: Boolean }) round = false;
  @property({ type: Boolean }) isHideTitle = undefined;
  @property({ type: String }) title = "Toggle Switch";
  @property({ type: String }) name = "";
  @property({ type: String }) value = "";
  @property({ type: String }) labelPosition = "right";
  @property({ type: Boolean}) overrideColor = false;
  @property({ type: String }) bgColorOn = "#2196f3";
  @property({ type: String }) bgColorOff = "#eeeeee";
  @property({ type: String }) thumpColorOn = "#fff";
  @property({ type: String }) thumpColorOff = "#fff";

  toggleSwitch() {
    this.checked = !this.checked;
    this.dispatchEvent(new CustomEvent("change", { detail: { checked: this.checked } }));
  }

  updateSliderColor() {
    this.style.setProperty("--pg-toggle-bg-color", this.bgColorOn);
    this.style.setProperty("--pg-toggle-bg-color-off", this.bgColorOff);
    this.style.setProperty("--pg-thump-color", this.thumpColorOn);
    this.style.setProperty("--pg-thump-color-off", this.thumpColorOff);
  }

  removeSliderColor(){
    this.style.removeProperty("--pg-toggle-bg-color");
    this.style.removeProperty("--pg-toggle-bg-color-off");
    this.style.removeProperty("--pg-thump-color");
    this.style.removeProperty("--pg-thump-color-off");
  }

  updated(changedProperties: Map<string | number | symbol, unknown>) {
    super.updated(changedProperties);
    if ((
      changedProperties.has("bgColorOff") ||
      changedProperties.has("bgColorOn") ||
      changedProperties.has("thumpColorOn") ||
      changedProperties.has("thumpColorOff")
    ) && this.overrideColor) {
      this.updateSliderColor();
    }

    if(changedProperties.has("overrideColor")){
      if(this.overrideColor === false){
        this.removeSliderColor();
      } else {
        this.updateSliderColor();
      }
    }
  }

  render() {
    const roundClass = this.round ? "round" : "";
    const labelClass =
      this.labelPosition === "top"
        ? "label-top"
        : this.labelPosition === "bottom"
        ? "label-bottom"
        : this.labelPosition === "left"
        ? "label-left"
        : "label-right";

    return html`
      <div class="pgd-web-switch form-check  ${labelClass}">
        <div class="switch">
        <label for="custom-switch" class="form-check-label">
          <input
            id="custom-switch"
            type="checkbox"
            class="form-check-input input-switch"
            name=${this.name}
            value=${this.value}
            @change=${this.toggleSwitch}
            .checked=${this.checked}
          /><span class="slider ${roundClass}"></span>
        </div>
        ${this.isHideTitle ? this.title : ""}</label>
      </div>
    `;
  }

  static styles = css`
    :host {
      display: block;
      width: fit-content;
      --slider-color-off: var(--pg-toggle-bg-color-off, "#eeeeee");
      --slider-color-checked: var(--pg-toggle-bg-color, "#2196f3");
      --slider-thump-color-off: var(--pg-thump-color-off, "#fff");
      --slider-thump-color-checked: var(--pg-thump-color, "#fff");
    }
    .pgd-web-switch {
      display: flex;
      align-items: center;
      padding: 0px;
    }

    .switch {
      position: relative;
      display: inline-block;
      width: 50px;
      height: 24px;
      margin: 8px;
    }

    .switch .input-switch {
      opacity: 0;
      width: 0;
      height: 0;
    }

    .slider {
      position: absolute;
      cursor: pointer;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: var(--slider-color-off);
      -webkit-transition: 0.4s;
      transition: 0.4s;
    }

    .slider:before {
      position: absolute;
      content: "";
      height: 16px;
      width: 16px;
      left: 4px;
      bottom: 4px;
      background-color: var(--slider-thump-color-off);
      -webkit-transition: 0.4s;
      transition: 0.4s;
      box-shadow: 0px 3px 3px rgba(0, 0, 0, 0.2);
    }

    .input-switch:checked + .slider {
      background-color: var(--slider-color-checked);
    }
    .input-switch:checked + .slider:before {
      background-color: var(--slider-thump-color-checked);
    }

    .input-switch:focus + .slider {
      box-shadow: 0 0 1px var(--slider-color-checked);
    }

    .input-switch:checked + .slider:before {
      -webkit-transform: translateX(26px);
      -ms-transform: translateX(26px);
      transform: translateX(26px);
    }

    .slider.round {
      border-radius: 34px;
    }

    .slider.round:before {
      border-radius: 50%;
    }

    .label-top {
      display: flex;
      flex-direction: column-reverse;
    }

    .label-bottom {
      display: flex;
      flex-direction: column;
    }

    .label-left {
      display: flex;
      flex-direction: row-reverse;
    }

    .label-right {
      display: flex;
      flex-direction: row;
    }
  `;
}
